"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interval = void 0;

var _IntervalObservable = require("./IntervalObservable");

var interval = _IntervalObservable.IntervalObservable.create;
exports.interval = interval;